import { AdCardIndexSet } from "~/components/story-style/story-style-layout/consts";

type GetCardTypeParameters = {
  currentIndex: number;
  maximumCardIndex: number;
};

export function getCurrentDisplayType(parameters: GetCardTypeParameters) {
  const { currentIndex, maximumCardIndex } = parameters;

  if (currentIndex === maximumCardIndex) {
    return "newsletter-sign-up";
  } else if (AdCardIndexSet.has(currentIndex)) {
    return "advertisement";
  }

  return "article";
}
